
<p-confirmDialog [key]="'global'" [style]="{width: '30%'}">
    <ng-template pTemplate="message" let-content>
        @if(content.message === 'publication' || content.message === 'archive' || content.message === 'correction') {
            <div class="confirm-dialog__container">
                <div class="confirm-dialog__content">
                    <div class="confirm-dialog__content__icon">
                        @if (content.message === 'publication') {
                            <img [src]="'assets/images/icons/stamp.svg'" width="32px"/>
                        } @else if (content.message === 'archive') {
                            <i class="bi bi-archive-fill"></i>
                        } @else {
                            <i class="bi bi-pen-fill"></i>
                        }
                    </div>
      
                    <div class="confirm-dialog__content__text" [innerHTML]="('modal.' + content.message + '.content') | translate"></div>
                </div>
    
                <div class="confirm-dialog__footer">
                    <i-button
                        [text]="content.acceptLabel"
                        [styleClass]="content.message === 'publication' ? 'green' : content.message === 'archive' ? 'red' : 'orange'"
                        [icon]="content.acceptIcon"
                        (click)="content.accept()">
                    </i-button>
                </div>
            </div>
        } @else {
            {{ content.message }}
        }
    </ng-template>
</p-confirmDialog>